import '../assets/NcAssistantButton-owGSr0s0.css';
import { defineComponent, createElementBlock, openBlock, normalizeClass, createVNode, createSlots, withCtx, createBlock, unref, createElementVNode, renderSlot, createTextVNode, toDisplayString } from "vue";
import { j as mdiCreation } from "./mdi-Cjx8NyEs.mjs";
import { N as NcAssistantIcon } from "./NcAssistantIcon-ClJKOiGi.mjs";
import { N as NcButton } from "./NcButton-DkC5k3Lb.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-5AA93z-F.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAssistantButton",
  props: {
    disabled: { type: Boolean },
    text: { default: "" },
    variant: { default: "secondary" }
  },
  emits: ["click"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{
          [_ctx.$style.assistantButton_disabled]: _ctx.disabled,
          [_ctx.$style.assistantButton_primary]: _ctx.variant === "primary"
        }, _ctx.$style.assistantButton])
      }, [
        createVNode(NcButton, {
          class: normalizeClass(_ctx.$style.assistantButton__button),
          disabled: _ctx.disabled,
          variant: "tertiary",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
        }, createSlots({
          icon: withCtx(() => [
            _ctx.variant === "primary" ? (openBlock(), createBlock(NcIconSvgWrapper, {
              key: 0,
              class: normalizeClass(_ctx.$style.assistantButton__icon),
              path: unref(mdiCreation)
            }, null, 8, ["class", "path"])) : (openBlock(), createBlock(NcAssistantIcon, { key: 1 }))
          ]),
          _: 2
        }, [
          _ctx.text || _ctx.$slots.default ? {
            name: "default",
            fn: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(_ctx.$style.assistantButton__text)
              }, [
                renderSlot(_ctx.$slots, "default", {}, () => [
                  createTextVNode(toDisplayString(_ctx.text), 1)
                ])
              ], 2)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["class", "disabled"])
      ], 2);
    };
  }
});
const assistantButton = "_assistantButton_1xe1x_20";
const assistantButton_disabled = "_assistantButton_disabled_1xe1x_30";
const assistantButton_primary = "_assistantButton_primary_1xe1x_34";
const assistantButton__icon = "_assistantButton__icon_1xe1x_38";
const assistantButton__text = "_assistantButton__text_1xe1x_39";
const assistantButton__button = "_assistantButton__button_1xe1x_42";
const style0 = {
  "material-design-icon": "_material-design-icon_1xe1x_12",
  assistantButton,
  assistantButton_disabled,
  assistantButton_primary,
  assistantButton__icon,
  assistantButton__text,
  assistantButton__button
};
const cssModules = {
  "$style": style0
};
const NcAssistantButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAssistantButton as N
};
//# sourceMappingURL=NcAssistantButton-BdYyxDoX.mjs.map
